import React from "react";

/**
 * Reusable blinking overlay message component
 *
 * Props:
 * - title (string): main heading message (e.g., “Uploading your file...”)
 * - subtitle (string): secondary text (e.g., “Please don’t refresh or close this page.”)
 * - position (object): optional custom positioning (top, left, bottom, right)
 * - visible (boolean): controls whether to show or hide the component
 *
 * Example usage:
 * <BlinkingOverlayMessage
 *   visible={loading}
 *   title="Uploading your file..."
 *   subtitle="Please don’t refresh or close this page until upload completes."
 *   position={{ top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}
 * />
 */
function BlinkingOverlayMessage({ title, subtitle, position = {}, visible = false }) {
  if (!visible) return null;

  return (
    <div
      style={{
        position: "absolute",
        zIndex: 9999,
        textAlign: "center",
        // backgroundColor: "rgba(255, 255, 255, 0.95)",
        // boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        borderRadius: "8px",
        padding: "20px 30px",
        animation: "blink 1.5s infinite",
        width: "auto",
        ...position,
      }}
    >
      <h6
        style={{
          fontWeight: 700,
          fontSize: "1rem",
          color: "#DC0E0E",
          marginBottom: "8px",
        }}
      >
        {title}
      </h6>
      <p
        style={{
          fontSize: "0.9rem",
          color: "#DC0E0E",
          margin: 0,
        }}
      >
        {subtitle}
      </p>

      {/* Define blinking animation inline */}
      <style>
        {`
          @keyframes blink {
            0% { opacity: 1; }
            50% { opacity: 0.4; }
            100% { opacity: 1; }
          }
        `}
      </style>
    </div>
  );
}

export default BlinkingOverlayMessage;
